<div class="advertisement_contract text-center position-relative">
    <ng-container *ngIf="IsLoadingContractFile">
        <app-loader [sm]="true" size="fa-5x"/> 
    </ng-container>
    <iframe
        #IFrame
        class="w-100"
        title="عرض المخطط"
        allowFullscreen="true"
        allow="xr-spatial-tracking"
        referrerpolicy="origin-when-cross-origin"
        [src]="'https://view.officeapps.live.com/op/embed.aspx?src=https://api-stg.saaei.co/media/5691604b-8c5e-423f-a0e1-fc6c74f3be30.docx' | safeUrl : URL_TYPE.resourceURL"
    >
    </iframe>
    <app-check-box
        name="acceptContract"
        [markAsRequired]="true"
        [validatorsErrorMsg]="false"
        label="الموافقة علي شروط العقد"
        [formControl]="AcceptContractControl"
        class="d-block margin_top_3 text-start"
    />
    <app-btn 
        title="استكمل الحجز"
        ClassBtn="margin_top_4"
        (click)="AcceptContract()"
        [disabled]="AcceptContractControl.invalid"
    />
</div>